export const getPageContent = (pageItem: PageOverview | undefined) => {
  const { $apiMethods } = useNuxtApp() as any
  return $apiMethods.loadJSONApi(
    $apiMethods.getLinkFromPageItem(pageItem)
  );
}

export const getNVEARContent = (contentType: string, nvearChild: string | undefined) => {
  const { $apiMethods } = useNuxtApp() as any
  return $apiMethods.loadJSONApi(
    $apiMethods.getLinkFromtNewsEventvacancyItem(contentType, nvearChild)
  );
}